import { render, staticRenderFns } from "./receiverselector.vue?vue&type=template&id=42f9eb5e"
import script from "./receiverselector.vue?vue&type=script&lang=js"
export * from "./receiverselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports